<template>
    <article>
    <h1>{{$t('maintenance_title')}}</h1>
    <div>
        <p>{{$t('maintenance_sub_heading1')}}</p>
        <p>{{$t('maintenance_sub_heading2')}} <router-link to="/global/contact-inqury">{{$t('maintenance_sub_heading3')}}</router-link> {{$t('maintenance_sub_heading4')}}</p>
        <p>&mdash; E3 Team</p>
    </div>
</article>
</template>

<script>
import {EventBus} from "../../../main.js";
import axios from "axios";
export default {
  data(){
    return{
      IpAddress: false
    }
  },
  mounted(){
    this.getIPAddress()
  },
  methods: {
      getIPAddress(){
        axios
        .get("/check-maintenance")
        .then(res => {
          if(!res.data.maintenance)
          {
            EventBus.$emit("notificationHide", res.data.maintenance);
            window.history.back();
          }
          else{
            EventBus.$emit("notificationHide", res.data.maintenance);
          }
       
        })
        .catch(error => console.log(error));
    },
  }
}
</script>

<style scoped>
  h1 { font-size: 50px; }
  article { 
      font: 20px Helvetica, sans-serif; 
      color: #333;
      text-align: center;
      padding: 150px;
      display: block; 
      text-align: left; 
      width: 100%; 
      margin: 0 auto; 
    }
  a { 
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
    }
  a:hover { 
    color: #0056b3;
    text-decoration: underline;
   }
</style>
